var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('StyleEditor',{ref:"styleEditor",attrs:{"code":_vm.currentStyle}}),_vm._v(" "),_c('ResumeEditor',{ref:"resumeEditor",attrs:{"markdown":_vm.currentMarkdown,"enableHtml":_vm.enableHtml}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703c1481","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Mobile.vue
// module id = null
// module chunks = 